import { IPlayerRootReducerShape } from '../rootPlayerStore';

export const getAlternativeDurationLine = (state: IPlayerRootReducerShape) =>
  state.miscScreenObjects.alternativeDurationLine;

export const getAlternativeDurationLinePercents = (
  state: IPlayerRootReducerShape
) => state.miscScreenObjects.alternativeDurationLine?.percents;
